// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file public/geo.proto (package public, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { EmptySchema } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_empty } from "@bufbuild/protobuf/wkt";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file public/geo.proto.
 */
export const file_public_geo: GenFile = /*@__PURE__*/
  fileDesc("ChBwdWJsaWMvZ2VvLnByb3RvEgZwdWJsaWMiPAoOR2V0R2VvUmVzcG9uc2USFAoMY291bnRyeV9jb2RlGAEgASgJEhQKDGNvdW50cnlfbmFtZRgCIAEoCTJJCg1HZW9SUENTZXJ2aWNlEjgKBkdldEdlbxIWLmdvb2dsZS5wcm90b2J1Zi5FbXB0eRoWLnB1YmxpYy5HZXRHZW9SZXNwb25zZWIGcHJvdG8z", [file_google_protobuf_empty]);

/**
 * @generated from message public.GetGeoResponse
 */
export type GetGeoResponse = Message<"public.GetGeoResponse"> & {
  /**
   * @generated from field: string country_code = 1;
   */
  countryCode: string;

  /**
   * @generated from field: string country_name = 2;
   */
  countryName: string;
};

/**
 * Describes the message public.GetGeoResponse.
 * Use `create(GetGeoResponseSchema)` to create a new message.
 */
export const GetGeoResponseSchema: GenMessage<GetGeoResponse> = /*@__PURE__*/
  messageDesc(file_public_geo, 0);

/**
 * @generated from service public.GeoRPCService
 */
export const GeoRPCService: GenService<{
  /**
   * @generated from rpc public.GeoRPCService.GetGeo
   */
  getGeo: {
    methodKind: "unary";
    input: typeof EmptySchema;
    output: typeof GetGeoResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_public_geo, 0);

